import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Box, Container, Divider, makeStyles } from "@material-ui/core";
import { Page, FooterSmall, OtherServices } from "@packages/ui";
import getBrandFromUrl from "../../utils/getBrandFromUrl";
import * as constants from "../../utils/constants";
import RentalManageForm from "src/components/RentalManageForm";
import getServiceFromUrl from "../../utils/getServiceFromUrl";
import getCountryFromURL from "src/utils/getCountryFromUrl";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
  },
  tile: {
    width: "100%",
  },
  container: {
    backgroundColor: "white",
    paddingTop: 35,
    paddingBottom: 20,
    borderRadius: 5,
    [theme.breakpoints.up("xs")]: { border: "none", borderRadius: 0 },
    [theme.breakpoints.up("sm")]: {
      border: "solid 1px lightgrey",
      borderBottom: `solid 5px ${theme.palette.primary.main}`,
      borderRadius: 5,
    },
  },
  box: {
    [theme.breakpoints.up("xs")]: {
      marginTop: -30,
    },
    [theme.breakpoints.up("md")]: {
      marginTop: -80,
    },
    [theme.breakpoints.up("lg")]: {
      marginTop: -110,
    },
    [theme.breakpoints.up("xl")]: {
      marginTop: -150,
    },
    marginBottom: 50,
  },
}));

const LoginView = () => {
  const classes = useStyles();
  const brand = getBrandFromUrl();
  const country = getCountryFromURL().toLowerCase();
  const navigate = useNavigate();
  const location = useLocation();
  const otherService =
    brand == "Dollar" || brand == "Thrifty" ? (
      <div></div>
    ) : (
      <OtherServices brand={brand} country={country} />
    );
  // Check if country is missing from URL and redirect with country
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const countryParam = urlParams.get("country");
    const brandParam = urlParams.get("brand");

    if (!countryParam && country) {
      // Add country to URL if missing
      urlParams.set("country", country);
      if (brandParam) {
        urlParams.set("brand", brandParam);
      }
      navigate(`${location.pathname}?${urlParams.toString()}`, { replace: true });
    }
  }, [location, country, navigate]);
  return (
    <Page
      className={classes.root}
      title="Login - Rental Manage"
      style={{ background: "white", textAlign: "center" }}
    >
      <img
        src={
          brand === "Ace"
            ? constants.ACE_RENTAL_EXTENSION_BANNER
            : brand === "Firefly"
            ? constants.ACE_RENTAL_EXTENSION_BANNER
            : brand === "Dollar"
            ? constants.DOLLAR_RENTAL_EXTENSION_BANNER
            : brand === "Thrifty"
            ? constants.THRIFTY_RENTAL_EXTENSION_BANNER
            : constants.HERTZ_RENTAL_EXTENSION_BANNER
        }
        width="100%"
      />
      <Box display="flex" flexDirection="row" justifyContent="center" className={classes.box}>
        <Container maxWidth="sm" className={classes.container}>
          <RentalManageForm brand={brand} country={country} />
          <Divider style={{ marginTop: 50, marginBottom: 40 }} />
          {otherService}
          <FooterSmall brand={brand} />
        </Container>
      </Box>
    </Page>
  );
};

export default LoginView;
